import useAuth from './useAuth';

const useIsAuthenticated = () => {
  const auth = useAuth();

  return auth.isAuthenticated;
};

export default useIsAuthenticated;
